var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_243_5206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9561 15.9984C15.3092 16.4297 14.5579 16.6576 13.7832 16.6576C13.0086 16.6576 12.2572 16.4297 11.6104 15.9984L0.956316 8.89553C0.897207 8.85612 0.839621 8.81504 0.783203 8.77279V20.4117C0.783203 21.7461 1.86611 22.8052 3.17668 22.8052H24.3897C25.7241 22.8052 26.7832 21.7223 26.7832 20.4117V8.77274C26.7266 8.81509 26.6689 8.85627 26.6097 8.89573L15.9561 15.9984Z",
    fill: "#C71324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.80137 7.62793L12.4554 14.7309C12.8587 14.9998 13.3209 15.1342 13.7832 15.1342C14.2454 15.1342 14.7077 14.9997 15.111 14.7309L25.765 7.62793C26.4026 7.20315 26.7832 6.49221 26.7832 5.72491C26.7832 4.40556 25.7098 3.33224 24.3905 3.33224H3.17586C1.85657 3.3323 0.783203 4.40561 0.783203 5.72617C0.783203 6.49221 1.16386 7.20315 1.80137 7.62793Z",
    fill: "#C71324"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243_5206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0.783203 0.0687256)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailRed);
export default __webpack_public_path__ + "static/media/mailRed.ee9a5e8c1b6f81bb9dce0794d1845a68.svg";
export { ForwardRef as ReactComponent };